import { EntityList } from '@/common/entityFramework/entityList/EntityList';

export const RqmtList = () => {
  return <EntityList entity="RQMT" />;
};
